import { FC } from 'react';
import { Badge, Text } from '../../../shared/uiComponents';
import { InsuranceDetailProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';

interface SubInsurancesCardProps {
	insurance: InsuranceDetailProperties;
}

const SubInsurancesCard: FC<SubInsurancesCardProps> = ({ insurance }) => {
	if (!insurance.subInsurances || insurance.subInsurances.length === 0) {
		return null;
	}

	return (
		<div className="insuranceDetailCard">
			<Text title="Sub-Insurances" type="h6" fontWeight="semiBold" />
			<div style={{ marginTop: '20px' }}>
				{insurance.subInsurances.map((sub) => (
					<div key={sub.id} className="insuranceDetailInfoRow">
						<Text title={sub.name} type="psm" />
						<Badge
							label={sub.canBeAssigned ? 'Assignable' : 'Not Assignable'}
							type={sub.canBeAssigned ? 'success' : 'gray'}
							sizeType="sm"
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default SubInsurancesCard;
